export default "__VITE_PUBLIC_ASSET__f64e9b1a__"